import { z } from 'zod';
const UpdateMttStagingPlayerReadyStateInboundSchema = z
    .object({
    playerId: z.number(),
    isMttReady: z.boolean()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'mtt_update_player_ready_state',
    ...rest
}));
export const UPDATE_MTT_STAGING_PLAYER_READY_STATE_PAYLOAD_DEFINITION = {
    zodSchema: UpdateMttStagingPlayerReadyStateInboundSchema
};
